import React, { useCallback, useEffect, useState } from "react";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay } from "API/commonApi";
import { AfDataType as ADT } from "utils/TableColumnData";
import { useFormik } from "formik";
import { AxiosResponse } from "axios";
import UseToast from "utils/AfToast";
import { debounce } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { constantValues } from "utils/constant";
import { number, object, string } from "yup";
import handleWheel from "utils/handleOnWheel";
import { Img } from "components";

export type AfTableProps = Partial<{}>;

const IntlRateCalculator: React.FC<AfTableProps> = ({}) => {
  const navigate = useNavigate();

  const peiceData = [
    {
      label: "Weight",
      key: "weight",
      type: ADT.NUMBER,
    },
    {
      label: "L",
      key: "l",
      type: ADT.NUMBER,
    },
    {
      label: "B",
      key: "b",
      type: ADT.NUMBER,
    },
    {
      label: "H",
      key: "h",
      type: ADT.NUMBER,
    },
  ];
  const columnData = [
    {
      label: "Country",
      key: "country",
      type: ADT.DB,
      db: "country",
      db_col: "country_name",
    },
    {
      label: "Dox/Non Dox",
      key: "isdoc",
      type: ADT.SELECT,
      options: [
        { value: "dox", label: "DOX" },
        { value: "non-dox", label: "NON DOX" },
      ],
    },
    {
      label: "Is Commerical?",
      key: "isCommerical",
      type: ADT.SELECT,
      options: [
        { value: true, label: "YES" },
        { value: false, label: "NO" },
      ],
    },
    {
      label: "Sign Delivery?",
      key: "signDelivery",
      type: ADT.SELECT,
      options: [
        { value: true, label: "YES" },
        { value: false, label: "NO" },
      ],
    },
  ];
  type OptionType = {
    value: number;
    label: string;
  };
  const defaultOptions: any = [{ value: 0, label: "Loading..." }];
  const [nestedTables, setNestedTables] = useState<any>({});
  const [nestedSelectedOptions, setNestedSelectedOptions] = useState<any>({});
  const [rate, setRate] = useState([]);

  const [peices, setPeices] = useState<any[]>([{ l: "", b: "", h: "", weight: "" }]);
  const addNewPeice = () => {
    let _peices = [...peices];
    _peices.push({ l: "", b: "", h: "", weight: "" });
    setPeices(_peices);
  };
  const removeLastPeice = () => {
    let _peices = [...peices];
    _peices.pop();
    setPeices(_peices);
  };

  useEffect(() => {
    let proms = [];

    let nestedApiData = {};
    columnData.forEach((cd) => {
      if (cd.type == ADT.DB) {
        proms.push(
          new Promise((res, rej) => {
            ListCommanWay(`/admin/${cd.db}/list`, {}, { paginate: 1000 })
              .then((x) => {
                let data: OptionType[] = [];
                if (x.status == "SUCCESS") {
                  let ary = [...x.data.data];

                  data = ary.map((d) => {
                    if (cd.db == "country") {
                      return { value: d.country_code, label: d[cd.db_col] };
                    } else {
                      return { value: d.id, label: d[cd.db_col] };
                    }
                  });
                  nestedApiData[cd.db] = data;
                }
                res(1);
              })
              .catch((c) => {
                res(0);
              });
          })
        );
      }
    });

    Promise.all(proms).then((x) => {
      setNestedTables(nestedApiData);
    });
  }, []);

  const {
    mutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        const fetchData = data.data;
        console.log("-------------->data.data", data.data);

        if (fetchData) {
          setRate(fetchData);
        }
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });
  const apiUrl = `/admin/rate/intl-calculate`;

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, setErrors, touched, dirty, setFieldValue } = useFormik({
    validationSchema: object().shape({}),
    initialValues: {
      l: "",
      b: "",
      h: "",
      weight: "",
      country: "",
      isdoc: "",
      isCommerical: false,
      signDelivery: false,
    },
    onSubmit: async (values, { resetForm }) => {
      console.log("valuesssss", values);
      let _values:any = {...values};
      _values.peices = peices;
      setRate([]);
      //setPeices([{ l: "", b: "", h: "", weight: "" }]);
      mutate({
        url: apiUrl,
        data: _values,
      });
    },
  });
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(value);
  return (
    <div className="p-5">
      <form
        className="flex flex-col"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        <div className="grid grid-cols-4 gap-4">
          {columnData.map((c) => {
            switch (c.type) {
              case ADT.NUMBER:
                return (
                  <div key={"general_" + c.key}>
                    <label htmlFor={"general_" + c.key} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {c.label}
                    </label>
                    <input
                      type="number"
                      id={"general_" + c.key}
                      className={` bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                      placeholder={c.label}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name={c.key}
                      value={values[c.key]}
                      onWheel={handleWheel}
                    />

                    <p className="mt-21 text-sm text-red-600">{touched[c.key] && Boolean(errors[c.key]) ? errors[c.key]+"" : ""}</p>
                  </div>
                );
                break;
              case ADT.TEXT:
                return (
                  <div key={"general_" + c.key}>
                    <label htmlFor={"general_" + c.key} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {c.label}
                    </label>
                    <input
                      type="text"
                      id={"general_" + c.key}
                      className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                      placeholder={c.label}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name={c.key}
                      value={values[c.key]}
                    />

                    <p className="mt-21 text-sm text-red-600">{touched[c.key] && Boolean(errors[c.key]) ? errors[c.key]+"" : ""}</p>
                  </div>
                );
                break;
              case ADT.DB:
                return (
                  <div key={"general_" + c.key}>
                    <label htmlFor={"general_" + c.key} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {c.label}
                    </label>

                    <Select
                      key={"select-" + (nestedTables[c.db] ? nestedTables[c.db].length : "undef")}
                      className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full`}
                      id={"general_" + c.key}
                      options={nestedTables[c.db] ? nestedTables[c.db] : defaultOptions}
                      onChange={(el) => {
                        setFieldValue(c.key, el.value);
                      }}
                      name={c.key}
                      value={nestedSelectedOptions[c.db]}
                    />

                    <p className="mt-21 text-sm text-red-600">{touched[c.key] && Boolean(errors[c.key]) ? errors[c.key]+"" : ""}</p>
                  </div>
                );
                break;
              case ADT.SELECT:
                return (
                  <div key={"general_" + c.key}>
                    <label htmlFor={"general_" + c.key} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      {c.label}
                    </label>

                    <Select
                      key={"select-" + c.key}
                      className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full`}
                      id={"general_" + c.key}
                      options={c?.options}
                      onChange={(el) => {
                        setFieldValue(c.key, el.value);
                      }}
                      name={c.key}
                      //   value={values[c.key]}
                      value={nestedSelectedOptions[c.db]}
                    />

                    <p className="mt-21 text-sm text-red-600">{touched[c.key] && Boolean(errors[c.key]) ? errors[c.key]+"" : ""}</p>
                  </div>
                );
                break;
              case ADT.TEXTAREA:
                break;
              case ADT.DATETIME:
                break;
              case ADT.FILE:
                break;
              default:
                return <></>;
                break;
            }
          })}
        </div>

        <div className="flex flex-col gap-2 mt-6 justify-center border-2 p-4 mb-4 rounded-md ">
          {peices.map((p, i) => {
            return (
              <div className="flex gap-4 justify-center items-end rounded-md" key={"peice-row-"+i}>
                {i + 1 == peices.length ? (
                  <>
                    <button type="button" className="w-10 h-10 bg-primary rounded-md text-white" onClick={addNewPeice}>
                      +
                    </button>
                    {peices.length > 1 && (
                      <button type="button" className="w-10 h-10 bg-red-500 rounded-md text-white" onClick={removeLastPeice}>
                        -
                      </button>
                    )}
                  </>
                ) : (
                  <>
                    <button type="button" className="w-10 h-10 opacity-0 pointer-events-none">
                      +
                    </button>
                    <button type="button" className="w-10 h-10 opacity-0 pointer-events-none">
                      +
                    </button>
                  </>
                )}
                {peiceData.map((pp) => {
                  return (
                    <div key={"general_" + pp.key + "_" + i}>
                      <label
                        htmlFor={"general_" + pp.key + "_" + i}
                        className="block mb-0.5 text-sm font-medium text-gray-900 dark:text-white"
                      >
                        {pp.label}
                      </label>
                      <input
                        type="number"
                        id={"general_" + pp.key + "_" + i}
                        className={` bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1`}
                        onChange={(e) => {
                          let _peices = [...peices];
                          _peices[i][pp.key] = e.target.value;
                          setPeices(_peices);
                        }}
                        value={p[pp.key]}
                        onWheel={handleWheel}
                      />
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>

        <button
          type="submit"
          className="px-4 py-2 text-sm self-end font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
        >
          Get
        </button>
        <div className="flex flex-col items-center gap-5 justify-center flex-1 w-full">
          <div className="">
            <table>
              <thead>
                <tr className="border-b-2 border-blue-700">
                  <th className="px-4 border-r border-l border-blue-700">Provider</th>
                  <th className="px-4 border-r border-blue-700">Base Amt</th>
                  <th className="px-4 border-r border-blue-700">Fuel Surcharge</th>
                  <th className="px-4 border-r border-blue-700">Fuel Surcharge</th>
                  <th className="px-4 border-r border-blue-700">Tax (18%)</th>
                  <th className="px-4 border-r border-blue-700">Total</th>
                </tr>
              </thead>

              <tbody>
                {rate.map((r) => {
                  let withFuel = r.val + (r.val * r.fuel) / 100;

                  return r.val != -1 ? (
                    <tr key={r.name} className="border-b border-blue-600">
                      <td className="text-right px-6 py-2 border-r border-l border-blue-700 flex items-center gap-2">
                        <Img src={"/" + r.name.replaceAll(" ", "_") + ".png"} className="h-12 ml-auto" />
                        {r.name}
                      </td>
                      <td className="text-right px-6 py-2 border-r border-blue-700">{numberFormat(r.val)}</td>
                      <td className="text-right px-6 py-2 border-r border-blue-700">{r.fuel} %</td>
                      <td className="text-right px-6 py-2 border-r border-blue-700">{numberFormat((r.val * r.fuel) / 100)}</td>
                      <td className="text-right px-6 py-2 border-r border-blue-700">{numberFormat(withFuel * 0.18)}</td>
                      <th className="text-right px-6 py-2 border-r border-blue-700">{numberFormat(withFuel + withFuel * 0.18)}</th>
                    </tr>
                  ) : (
                    ""
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </form>
    </div>
  );
};

export default IntlRateCalculator;
